"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _fuseUtils = require("@tvg/fuse-utils");
var _propTypes = _interopRequireDefault(require("prop-types"));
var _react = _interopRequireDefault(require("react"));
var _ellipses = require("./ellipses");
var _styledButton = _interopRequireDefault(require("./styled-button"));
var _styledPagination = require("./styled-pagination");
var _utils = require("./utils");
function _interopRequireDefault(e) {
  return e && e.__esModule ? e : {
    "default": e
  };
}
function _extends() {
  return _extends = Object.assign ? Object.assign.bind() : function (n) {
    for (var e = 1; e < arguments.length; e++) {
      var t = arguments[e];
      for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
    }
    return n;
  }, _extends.apply(null, arguments);
}
function _slicedToArray(r, e) {
  return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest();
}
function _nonIterableRest() {
  throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _unsupportedIterableToArray(r, a) {
  if (r) {
    if ("string" == typeof r) return _arrayLikeToArray(r, a);
    var t = {}.toString.call(r).slice(8, -1);
    return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0;
  }
}
function _arrayLikeToArray(r, a) {
  (null == a || a > r.length) && (a = r.length);
  for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e];
  return n;
}
function _iterableToArrayLimit(r, l) {
  var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
  if (null != t) {
    var e,
      n,
      i,
      u,
      a = [],
      f = !0,
      o = !1;
    try {
      if (i = (t = t.call(r)).next, 0 === l) {
        if (Object(t) !== t) return;
        f = !1;
      } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0);
    } catch (r) {
      o = !0, n = r;
    } finally {
      try {
        if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return;
      } finally {
        if (o) throw n;
      }
    }
    return a;
  }
}
function _arrayWithHoles(r) {
  if (Array.isArray(r)) return r;
} /* eslint-disable react/jsx-indent */
var useCallback = _react["default"].useCallback,
  useState = _react["default"].useState;
var ELLIPSES_ICON = 'PendingSimple';
var ENTER_KEY_CODE = 13;
var SPACE_KEY_CODE = 32;
var propTypes = {
  text: _propTypes["default"].string.isRequired,
  currentPage: _propTypes["default"].number.isRequired,
  callback: _propTypes["default"].func,
  seoHref: _propTypes["default"].oneOfType([_propTypes["default"].string, _propTypes["default"].bool])
};
var defaultProps = {
  callback: undefined,
  seoHref: false
};
function PaginationButton(_ref) {
  var text = _ref.text,
    currentPage = _ref.currentPage,
    callback = _ref.callback,
    seoHref = _ref.seoHref;
  var ellipsesIcon = text !== null && text !== void 0 && text.startsWith(_utils.ELLIPSES) ? ELLIPSES_ICON : undefined;
  var isDisabled = text === String(currentPage) || ellipsesIcon;
  var _useState = useState(false),
    _useState2 = _slicedToArray(_useState, 2),
    isFocused = _useState2[0],
    setIsFocused = _useState2[1];
  var href = seoHref && typeof seoHref === 'string' && !isDisabled ? seoHref : undefined;
  var onClickHandler = useCallback(function (event) {
    if (seoHref) event.preventDefault();
    if (callback) {
      var num = Number(text);
      var page = num > 0 ? num : 0;
      callback(event, page);
    }
  }, [callback, text]);
  var onKeyDownHandler = useCallback(function (event) {
    if ((event === null || event === void 0 ? void 0 : event.keyCode) === ENTER_KEY_CODE || (event === null || event === void 0 ? void 0 : event.keyCode) === SPACE_KEY_CODE) {
      setIsFocused(true);
    }
  }, []);
  var onBlurHandler = useCallback(function () {
    setIsFocused(false);
  }, []);
  var ariaProps = isDisabled ? {
    'aria-current': 'page'
  } : {};
  if (ellipsesIcon) {
    return /*#__PURE__*/_react["default"].createElement(_ellipses.Ellipses, null);
  }
  return /*#__PURE__*/_react["default"].createElement(_styledPagination.ListStyled, null, /*#__PURE__*/_react["default"].createElement(_styledButton["default"], _extends({
    onClick: onClickHandler,
    fullWidth: false,
    variant: "tertiary",
    disabled: !isFocused && isDisabled,
    className: isFocused && isDisabled && 'active-page',
    onKeyDown: onKeyDownHandler,
    onBlur: onBlurHandler,
    href: href
  }, ariaProps), /*#__PURE__*/_react["default"].createElement(_fuseUtils.SrOnly, null, "Page"), " ", text));
}
PaginationButton.propTypes = propTypes;
PaginationButton.defaultProps = defaultProps;
PaginationButton.displayName = 'PaginationButton';
var _default = exports["default"] = PaginationButton;